const HOUSING_CONNECTOR_NETWORK_OPTIONS: { [key: string]: string } = {
  global: 'Both Zillow Rental Network and Housing Connector',
  disabled: 'Only Zillow Rental Network',
  exclusive: 'Only Housing Connector',
};

const HOUSING_CONNECTOR_NETWORK_OPTIONS_KEYS = {
  GLOBAL: 'global',
  DISABLED: 'disabled',
  EXCLUSIVE: 'exclusive',
};

export { HOUSING_CONNECTOR_NETWORK_OPTIONS, HOUSING_CONNECTOR_NETWORK_OPTIONS_KEYS };
